export const AD_ROW = 4
export const AD_CELL_WIDTH = 2
export const AD_CELL_WIDTH_WIDE = 3
